import axios from "axios";

const obtenerPorPuesto = async idPuesto => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const userData = { nic: formattedNic, token: token, idPuesto, serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover") };

  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Despachos/GetDespachosReal`, userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const combustible = {
  obtenerPorPuesto,
};

export default combustible;
